<div
  class="message-content"
  [ngClass]="{'mine-message': message.role === 'user'}"
>

  <div class="message-wrapper">

    <span
      class="message"
      [ngClass]="{'typing': message.role === 'assistant'}"
      [ngStyle]="{'--n': message.content.length}"
    >
      <markdown
        id="markdown"
        [data]="message.display_msg || message.content"
      ></markdown>
    </span>

  </div>

</div>
